import { Fragment } from "react";

import { SUB_COLUMN_SEPARATOR } from "src/datasets/DatasetTable/utils";
import { Callout } from "src/design-system/Callout";

const renderColumnName = (name: string) => {
  if (name.includes(SUB_COLUMN_SEPARATOR)) {
    const [parentName, childName] = name.split(SUB_COLUMN_SEPARATOR);
    return `Child Flow connection ${childName} (called by ${parentName})`;
  } else {
    return name;
  }
};

export const MissingMockDataColumnsCallout: React.FC<{
  columns: string[];
  onAddMissingColumns: () => void;
}> = ({ columns, onAddMissingColumns }) => {
  const manyColumns = columns.length > 1;

  return (
    <Callout
      action={{
        text: "Add Missing Mock Data Fields",
        onClick: onAddMissingColumns,
      }}
      variant="warning"
      isEdgeToEdge
    >
      <div>
        <span className="pr-1">
          Add missing mock data field{manyColumns && "s"}
        </span>
        {columns.map((column, index) => (
          <Fragment key={column}>
            {index > 0 && ", "}
            <strong className="font-inter-medium-12px">
              {renderColumnName(column)}
            </strong>
          </Fragment>
        ))}{" "}
        to this dataset to be able to test this version
      </div>
    </Callout>
  );
};
